import { useMemo, useState } from "react";
import { useWorkshop } from "./useWorkshop";
import { SettingsContext } from "./settingsContextValue";
import { settingsService } from "../services/settingsService";
import {
  mergeSettings,
  getControlledFields,
  getControlledFeatureFields,
} from "../lib/settingsDefaults";

// Disponibiliza as configurações "efetivas" da oficina (cor, logo, tema,
// features), já mescladas entre o que está salvo localmente e o que o
// painel administrativo impôs via prop `config` no WorkshopProvider.
//
// `reloadToken` funciona como chave de cache para forçar a releitura do
// localStorage após um `updateSettings`, sem chamar setState dentro de um
// efeito (mesmo padrão usado em ChecklistApp/ClientesPage/VeiculosPage).
export function SettingsProvider({ children }) {
  const { workshopId, config: externalConfig } = useWorkshop();
  const [reloadToken, setReloadToken] = useState(0);

  const stored = useMemo(
    () => settingsService.get(workshopId),
    [workshopId, reloadToken]
  );

  const settings = useMemo(
    () => mergeSettings(stored, externalConfig),
    [stored, externalConfig]
  );

  const controlledFields = useMemo(() => getControlledFields(externalConfig), [externalConfig]);
  const controlledFeatureFields = useMemo(
    () => getControlledFeatureFields(externalConfig),
    [externalConfig]
  );

  function updateSettings(patch) {
    settingsService.save(workshopId, {
      ...stored,
      ...patch,
      features: { ...stored.features, ...(patch.features || {}) },
    });
    setReloadToken((t) => t + 1);
  }

  const value = {
    settings,
    updateSettings,
    isFieldControlled: (field) => controlledFields.has(field),
    isFeatureControlled: (field) => controlledFeatureFields.has(field),
  };

  return <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>;
}
